import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { PureComponent } from 'react';
import { Popper } from 'react-popper';
import { Keyframes, animated } from 'react-spring/renderprops.cjs';
import getComponentFromProps from '@elliemae/ds-utilities/getComponentFromProps';
import DSOverlay from '@elliemae/ds-overlay';
import { getArrowStylesBySize } from './getArrowStylesBySize.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Content = Keyframes.Spring({});

var PopperContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(PopperContent, _PureComponent);

  var _super = _createSuper(PopperContent);

  // eslint-disable-next-line react/static-property-placement
  function PopperContent(props) {
    var _this;

    _classCallCheck(this, PopperContent);

    _this = _super.call(this, props);
    _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_this));
    _this.renderArrow = _this.renderArrow.bind(_assertThisInitialized(_this));
    _this.handleRestAnimation = _this.handleRestAnimation.bind(_assertThisInitialized(_this));
    _this.handleRestAnimation = _this.handleRestAnimation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PopperContent, [{
    key: "handleRestAnimation",
    value: function handleRestAnimation() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          onContentDestroyed = _this$props.onContentDestroyed;

      if (!isOpen) {
        onContentDestroyed();
      }
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(_ref, placement) {
      var ref = _ref.ref,
          style = _ref.style;
      var _this$props2 = this.props,
          blockName = _this$props2.blockName,
          showArrow = _this$props2.showArrow;
      if (!showArrow) return null;
      return /*#__PURE__*/React.createElement("div", {
        key: "popper-arrow",
        ref: ref,
        className: "".concat(blockName || 'popper', "__arrow"),
        "data-placement": placement,
        style: _objectSpread(_objectSpread({}, style), getArrowStylesBySize(placement, 25))
      }, /*#__PURE__*/React.createElement("svg", {
        viewBox: "0 0 30 30"
      }, /*#__PURE__*/React.createElement("path", {
        className: "stroke",
        d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26 C26.7,29,24.6,28.1,23.7,27.1z"
      }), /*#__PURE__*/React.createElement("path", {
        className: "fill",
        d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"
      })));
    }
  }, {
    key: "renderContent",
    value: function renderContent(_ref2) {
      var _this2 = this;

      var ref = _ref2.ref,
          style = _ref2.style,
          placement = _ref2.placement,
          arrowProps = _ref2.arrowProps,
          scheduleUpdate = _ref2.scheduleUpdate,
          outOfBoundaries = _ref2.outOfBoundaries;
      var _this$props3 = this.props,
          contentComponent = _this$props3.contentComponent,
          contentStyle = _this$props3.contentStyle,
          isOpen = _this$props3.isOpen,
          closeAnimationConfig = _this$props3.closeAnimationConfig,
          openAnimationConfig = _this$props3.openAnimationConfig,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave,
          containerProps = _this$props3.containerProps,
          zIndex = _this$props3.zIndex,
          hideIfNotVisible = _this$props3.hideIfNotVisible;

      var computedStyle = _objectSpread(_objectSpread(_objectSpread({}, style), contentStyle), {}, {
        zIndex: zIndex
      });

      return /*#__PURE__*/React.createElement("div", _extends({}, containerProps, {
        "data-placement": placement,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: computedStyle,
        "data-testid": "popper-container"
      }), /*#__PURE__*/React.createElement(Content, {
        native: true,
        onRest: this.handleRestAnimation,
        state: isOpen && (!outOfBoundaries || !hideIfNotVisible) ? 'open' : 'close',
        states: {
          open: _objectSpread(_objectSpread({}, openAnimationConfig), {}, {
            from: closeAnimationConfig.to
          }),
          close: closeAnimationConfig
        }
      }, function (animationStyle) {
        return /*#__PURE__*/React.createElement(animated.div, {
          ref: ref,
          style: animationStyle
        }, getComponentFromProps(contentComponent, {
          scheduleUpdate: scheduleUpdate
        }, [_this2.renderArrow(arrowProps, placement)]));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          _this$props4$destroye = _this$props4.destroyed,
          destroyed = _this$props4$destroye === void 0 ? false : _this$props4$destroye,
          _this$props4$onClickO = _this$props4.onClickOutside,
          onClickOutside = _this$props4$onClickO === void 0 ? function () {
        return null;
      } : _this$props4$onClickO,
          _this$props4$placemen = _this$props4.placement,
          placement = _this$props4$placemen === void 0 ? 'bottom-start' : _this$props4$placemen,
          _this$props4$modifier = _this$props4.modifiers,
          modifiers = _this$props4$modifier === void 0 ? {} : _this$props4$modifier,
          referenceNode = _this$props4.referenceNode,
          _this$props4$usePorta = _this$props4.usePortal,
          usePortal = _this$props4$usePorta === void 0 ? true : _this$props4$usePorta;
      return /*#__PURE__*/React.createElement(DSOverlay, {
        isOpen: !destroyed,
        onClickOutside: onClickOutside,
        usePortal: usePortal
      }, /*#__PURE__*/React.createElement(Popper, {
        modifiers: modifiers,
        placement: placement,
        referenceElement: referenceNode
      }, this.renderContent));
    }
  }]);

  return PopperContent;
}(PureComponent);

_defineProperty(PopperContent, "defaultProps", {
  onContentDestroyed: function onContentDestroyed() {
    return null;
  }
});

export default PopperContent;
//# sourceMappingURL=PopperContent.js.map
